import styled from 'styled-components';

import { colors } from 'theme/colors';

export const TextArea = styled.textarea`
  appearance: none;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  color: ${({ theme }) => theme.palette.primary.dark};
  height: 38px;
  padding: 12px 12px;
  outline: none;

  .MuiSelect-select:disabled {
    background-color: ${colors.ui.border.main};
  }

  .MuiSelect-select {
    background-color: initial;
  }
  .MuiSelect-select:focus {
    margin-left: 16px;
  }
  width: 100%;
`;

export const TextInput = styled.input`
  appearance: none;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  color: ${({ theme }) => theme.palette.primary.dark};
  height: 40px;
  padding: 8px 16px;
  outline: none;

  .MuiSelect-select:disabled {
    background-color: ${colors.ui.border.main};
  }

  .MuiSelect-select {
    background-color: initial;
  }
  .MuiSelect-select:focus {
    margin-left: 16px;
  }
  width: 100%;
`;

export const StyledContainer = styled.div`
  width: 100%;
`;

export const TextComponent = styled.p<{ $empty?: boolean; disabled?: boolean }>`
  appearance: none;
  background-color: ${({ disabled }) => (disabled ? '#F3F4F5' : 'white')};
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  color: ${({ theme }) => theme.palette.primary.dark};
  font-size: 14px;
  margin: 0;
  height: 100%;
  padding: 8px 16px;
  outline: none;
  overflow-wrap: anywhere;
  -webkit-user-modify: read-write-plaintext-only;

  white-space: pre-wrap;

  &:before {
    content: ${(props) => (props.$empty ? 'attr(data-placeholder)' : '""')};
    font: inherit;
    letter-spacing: inherit;
    color: ${({ theme }) => theme.palette.text.secondary};
    margin: 0;
    position: absolute;
    pointer-events: none;
  }
`;
